import { Alert } from '@design/components/alert/Alert';
import { useDismissContinuous } from '@terminal/hooks/use-dismiss-continuous/useDismissContinuous';
import { addHours } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DISMISSED_KEY = '__toggle_dismissed_grace_period_alert';

export interface AlertGracePeriodProps {
  hoursRemaining: number;
  openEditCardModal: () => void;
}

export const AlertGracePeriod = ({
  hoursRemaining,
  openEditCardModal,
}: AlertGracePeriodProps) => {
  const { t } = useTranslation('subscription');

  const endDate = addHours(new Date(), hoursRemaining);
  const { isVisible, handleDismiss } = useDismissContinuous({
    endDate,
    cookieKey: DISMISSED_KEY,
    showBeforeInDays: 5,
  });

  const onClick = () => {
    handleDismiss();
    openEditCardModal();
  };

  return isVisible ? (
    <Alert
      data-testid="grace-period-toast-alert"
      title={t('subscription:alerts.gracePeriod.title')}
      message={t('subscription:alerts.gracePeriod.message')}
      primaryBtn={{
        label: t('subscription:alerts.gracePeriod.primaryBtnLabel'),
        onClick: onClick,
      }}
      onClose={handleDismiss}
    />
  ) : null;
};
